import foundationCss from '@/assets/styles/foundation-emails-2.2.1.min.extcss?raw';

/**
 * Ember's `{% include_foundation_css %}` liquid tag — the backend expands it
 * into the Foundation-for-Emails stylesheet when an email actually sends.
 */
export const FOUNDATION_LIQUID_TAG = '{% include_foundation_css %}';

/**
 * The Foundation stylesheet as an inline `<style>` block for the preview.
 *
 * A `<link>` to the bundled `.extcss` asset does NOT work inside the preview
 * `srcdoc` iframes: the dev/prod server serves `.extcss` with a non-CSS MIME
 * type (`application/json`), so the browser loads the file but refuses to
 * apply it as a stylesheet — leaving the email with only its inline styles
 * (unconstrained, full-bleed). Inlining the CSS as a `<style>` block sidesteps
 * both the MIME check and `srcdoc`'s base-URL resolution of relative hrefs.
 */
export const FOUNDATION_CSS_STYLE_TAG = `<style>${foundationCss}</style>`;
